<form #form="ngForm" (submit)="onSubmit(form)" [ngClass]="{'ng-submitted': form.submitted}"
      autocomplete="off">
    <div class="row m-b-sm">
        <div class="col-md-4">
            <label>Sharing</label>
        </div>
        <div class="col-md-8">
            <select class="form-control" name="isPublic"
                    [(ngModel)]="shareType"
                    (ngModelChange)="shareTypeChange($event)">
                <option [ngValue]="null">Staff only</option>
                <option *ngFor="let option of currentShareTypeOptions" [ngValue]="option.value">{{option.name}}</option>
            </select>
        </div>
    </div>

    <div *ngIf="shareType === shareTypes.Residents && permissionsList.length" class="row m-b-sm">
        <div class="col-md-4">
            <label>Occupancy Types</label>
        </div>
        <div class="col-md-8">
            <permissions-select [permissionsList]="permissionsList"
                                [permissions]="data.permissions"
                                (onChange)="this.data.permissions = $event">
            </permissions-select>
        </div>
    </div>

    <div *ngIf="shareType === shareTypes.Groups" class="row m-b-sm">
        <div class="col-md-4">
            <label>User Groups</label>
        </div>
        <div class="col-md-8">
            <angular2-multiselect
                name="userGroups"
                [data]="userGroups"
                [(ngModel)]="data.userGroups"
                [settings]="{
                                    singleSelection: false,
                                    text: 'Select User Groups',
                                    selectAllText: 'Select All',
                                    unSelectAllText: 'Deselect All',
                                    enableSearchFilter: true,
                                    classes: 'with-filter'
                                }">
            </angular2-multiselect>
        </div>
    </div>

    <div class="row m-b-sm" *ngIf="corporationNumbers &&
                                                !(corporationNumbers.length == 1 &&
                                                data.corporationNumbers.length == 1)">
        <div class="col-md-4">
            <label>Corporations</label>
        </div>
        <div class="col-md-8">
            <angular2-multiselect name="corporationNumbers"
                                  required
                                  [data]="corporationNumbers"
                                  [(ngModel)]="data.corporationNumbers"
                                  (onSelect)="getBuildingsForSelectedCorporations()"
                                  (onDeSelect)="getBuildingsForSelectedCorporations($event, 'deselect')"
                                  (onSelectAll)="getBuildingsForSelectedCorporations()"
                                  (onDeSelectAll)="getBuildingsForSelectedCorporations($event, 'deselectAll')"
                                  [settings]="{
                                                      singleSelection: false,
                                                      text: 'Select Corporations',
                                                      selectAllText: 'Select All',
                                                      unSelectAllText: 'Deselect All',
                                                      enableSearchFilter: true,
                                                      classes: 'with-filter'
                                                  }">
            </angular2-multiselect>
        </div>
    </div>

    <div class="row m-b-sm" *ngIf="buildings && buildings.length &&
                                            !(buildings.length == 1 &&
                                            data.buildings.length == 1)">
        <div class="col-md-4">
            <label>Buildings</label>
        </div>
        <div class="col-md-8">
            <angular2-multiselect name="buildings"
                                  required
                                  [data]="buildings"
                                  [(ngModel)]="data.buildings"
                                  [settings]="{
                                                      singleSelection: false,
                                                      text: 'Select Buildings',
                                                      selectAllText: 'Select All',
                                                      unSelectAllText: 'Deselect All',
                                                      enableSearchFilter: true,
                                                      classes: 'with-filter'
                                                  }">
            </angular2-multiselect>
        </div>
    </div>

    <div class="row m-b-sm">
        <div class="col-md-4">
            <label>Upload Files</label>
        </div>
        <div class="col-md-8">
            <label class="upload-file" for="file" [ngClass]="{'ng-invalid': !fileNames.length}">
                <input class="upload-file__input"
                       type="file"
                       name="file"
                       multiple
                       id="file"
                       #fileInput
                       (change)="onFileChange($event)">
                <div class="upload-file__value">
                    {{ data.files.length > 0 ? getFilesNamesString() : '' }}
                </div>
                <span class="upload-file__button">Browse</span>
            </label>
        </div>
    </div>

    <div class="row m-b-sm file-name-row" *ngFor="let name of fileNames; trackBy: trackByFn; let index = index;">
        <div class="col-md-4">
            <label *ngIf="index === 0">
                File Name<span *ngIf="fileNames.length > 1">s</span>
            </label>
        </div>
        <div class="col-md-8">
            <input type="text" name="fileName{{index}}" class="form-control" [(ngModel)]="fileNames[index]">
            <i class="fa fa-trash pull-right" (click)="removeFile(index)"></i>
        </div>
    </div>

    <ng-container *ngIf="hasAcceptableDates">
        <div class="row m-b-sm">
            <div class="col-md-4">
                <label>Visible from</label>
            </div>
            <div class="col-md-8">
                <date-select-field name="acceptableFrom" [(ngModel)]="visibleFrom"></date-select-field>
            </div>
        </div>

        <div class="row m-b-sm">
            <div class="col-md-4">
                <label>Visible to</label>
            </div>
            <div class="col-md-8">
                <date-select-field name="acceptableTo"
                                   [minDate]="visibleFrom"
                                   [(ngModel)]="visibleTo"></date-select-field>
            </div>
        </div>
    </ng-container>

    <div class="row m-b-sm">
        <div class="col-md-4">
            <label>Notify Users</label>
        </div>
        <div class="col-md-8">
            <label class="img-checkbox">
                <input name="notifyUsers"
                       id="notifyUsers"
                       type="checkbox"
                       [(ngModel)]="data.notifyUsers"
                       (ngModelChange)="notifyUsersValueChange($event)"
                >
                <label for="notifyUsers">
                    <svg-checked></svg-checked>
                </label>
            </label>
        </div>
    </div>

    <div class="btns-box m-t-md">
        <button type="submit" [disabled]="isShowPreloader" class="btn btn-primary save-folder-btn m-t-md">
            {{ submitText }}
        </button>
    </div>
</form>
<spinner [spinnerShow]="isPermissionsLoading || isShowPreloader || isCorporationLoading"></spinner>



// WEBPACK FOOTER //
// /app/src/app/views/documents/upload-file-modal/file-details-step/file-details-step.component.html